import type { TApproval } from '@modules/approvals';
import type { TVersion } from '@modules/documents';

import compareVersion from './compareVersion.helper';

/**
 * Resolves the default comparison base version for Changes mode.
 *
 * During an active approval, defaults to the approved version so reviewers
 * see all accumulated changes since the last approval. Otherwise defaults
 * to the immediately previous version (N-1).
 */
const resolveDefaultComparisonBase = (
  versions: TVersion[],
  viewedVersionId: string,
  approvals: TApproval[],
  approvedVersionId?: string
): string | undefined => {
  const previousVersionId = resolvePreviousVersionId(versions, viewedVersionId);

  const hasActiveApproval = approvals.some((a) => a.versionId === viewedVersionId && !a.dateCompleted);

  if (
    hasActiveApproval &&
    approvedVersionId &&
    compareVersion.isLessThan(approvedVersionId, viewedVersionId) &&
    versions.some((v) => v.id === approvedVersionId)
  ) {
    return approvedVersionId;
  }

  return previousVersionId;
};

export const resolvePreviousVersionId = (versions: TVersion[], viewedVersionId: string): string | undefined => {
  if (viewedVersionId === 'draft') return versions[0]?.id;

  const index = versions.findIndex((v) => v.id === viewedVersionId);
  if (index === -1) return undefined;
  return versions[index + 1]?.id;
};

export default resolveDefaultComparisonBase;
